import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  tbody > tr {
    cursor: pointer;
  }
`;

export const WrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  h1 {
    text-transform: uppercase;
    font-size: 1.2rem;
    margin-left: 1.5rem;
  }
`;

export const WrapperHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  //margin-bottom: 2rem;
  padding: 1rem 1rem 0;
`;

export const WrapperFormInput = styled.div`
  display: flex;
  gap: 1rem;
`;
